// Personal lib
import { UpdateServiceNameEnum } from './common/update-service-enum';
import { UpdateService } from './common/update-service.class';
import { apiHeadLiveness } from '@data/datasource/remote/health-check.api';
import { logger } from '@shared/lib/logger/logger-manager';
import { sessionManager } from '@shared/service/sessionManager/session-manager.class';

export interface IRefreshTokenChecker {
  silentRenew: boolean
}

export class UpdateManagerAuth {
  /**
   * UpdateService : liveness check
   */
  static AuthLiveness = class UpdateServiceLiveness extends UpdateService {
    updateServiceName = UpdateServiceNameEnum.LIVENESS;

    /**
     * Liveness test
     */
    async task() {
      apiHeadLiveness()
        .then((response: boolean) => {
          sessionManager.isOnline.value = response;

          if (response) logger?.info('[checkBackendState] - backend is online');
          else logger?.info('[checkBackendState] - backend is offline');
        })
        .catch(() => {
          sessionManager.isOnline.value = false;
          logger?.info('[checkBackendState] - backend is offline');
        })
    }
  };

  /**
   * UpdateService : refresh token checker
   */
  static RefreshTokenChecker = class UpdateServiceRefreshTokenChecker extends UpdateService {
    updateServiceName = UpdateServiceNameEnum.TOKEN_REFRESH;

    /**
     * Liveness test
     */
    async task(params: IRefreshTokenChecker) {
      await sessionManager.checkRefreshTokenValidity(params?.silentRenew);
    }
  };
}
